export default "__VITE_ASSET__CyTW4GXl__"